module.exports = __webpack_public_path__ + "img/7passenger_stopped.c426023c.svg";